(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 80580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(26564);
(function(){"use strict";var e={977:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t=process.cwd();n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(977);module.exports=t})();

/***/ }),

/***/ 11215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9652);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60822);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69515);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75360);


var _excluded = ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"];




var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_2__/* .tagPropType */ .iC,
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  body: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  outline: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  innerRef: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)])
};
var defaultProps = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'card', inverse ? 'text-white' : false, body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + "-" + color : false), cssModule);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 65322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9652);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60822);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69515);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75360);


var _excluded = ["className", "cssModule", "tag"];




var propTypes = {
  tag: _utils__WEBPACK_IMPORTED_MODULE_2__/* .tagPropType */ .iC,
  className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
  cssModule: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
var defaultProps = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  var classes = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .mapToCssModules */ .mx)(classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'card-header'), cssModule);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, attributes, {
    className: classes
  }));
};

CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(72978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hu": function() { return /* binding */ TabLabel; },
/* harmony export */   "I5": function() { return /* binding */ TabContent; },
/* harmony export */   "Jm": function() { return /* binding */ TabPane; },
/* harmony export */   "KT": function() { return /* binding */ TabNav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94273);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1890);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36996);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45679);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55097);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75740);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37536);
/* harmony import */ var src_components_Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59263);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 0 !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n  margin-top: -1px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: auto;\n  border: 1px #ccc9 solid;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-right-radius: 5px;\n  padding: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n\n  border: #ccc 1px solid;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n\n  background: #ddd;\n  min-width: 170px;\n\n  border-bottom: 0 !important;\n\n  margin-right: 0.25rem;\n  z-index: 2;\n\n  text-decoration: none !important;\n\n  .active {\n    font-weight: bold;\n    background-color: ",
        " !important;\n  }\n\n  .nav-link,\n  .nav-link:focus {\n    box-shadow: none !important;\n\n    &:hover {\n      box-shadow: none !important;\n    }\n  }\n\n  .nav-link.active,\n  .nav-link.active:focus {\n    box-shadow: none !important;\n  }\n\n  .nav-link.disabled {\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






function TabNav(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Nav, {
        tabs: true,
        children: children
    });
}
function TabLabel(_param) {
    var tabId = _param.tabId, activeTabId = _param.activeTabId, setActiveTabId = _param.setActiveTabId, children = _param.children, rest = _objectWithoutProperties(_param, [
        "tabId",
        "activeTabId",
        "setActiveTabId",
        "children"
    ]);
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setActiveTabId(tabId);
    }, [
        setActiveTabId,
        tabId
    ]);
    var active = activeTabId === tabId;
    var more = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (rest.href) {
            return {
                tag: src_components_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r,
                replace: true
            };
        }
        return {};
    }, [
        rest.href
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavItem, _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            active: active
        })
    }, rest, more, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavLink, {
            tag: "nav",
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                active: active
            }),
            onClick: onClick,
            children: children
        })
    }));
}
var Nav = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5e969eb3-0"
})(_templateObject());
var TabContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5e969eb3-1"
})(_templateObject1());
var TabPane = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5e969eb3-2"
})(_templateObject2());
var NavItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5e969eb3-3"
})(_templateObject3(), function(props) {
    return props.theme.white;
});
var NavLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(reactstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5e969eb3-4"
})(_templateObject4(), function(props) {
    return props.theme.bodyColor;
});


/***/ }),

/***/ 72978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ MainPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28354);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(60822);
// EXTERNAL MODULE: ./src/components/Layout/Layout.tsx + 23 modules
var Layout = __webpack_require__(62399);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(31382);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Row.js
var Row = __webpack_require__(19343);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Col.js
var Col = __webpack_require__(70146);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(16130);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(37536);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Card.js
var Card = __webpack_require__(11215);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardHeader.js
var CardHeader = __webpack_require__(65322);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/CardBody.js
var CardBody = __webpack_require__(14191);
;// CONCATENATED MODULE: ./src/components/Common/Card.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  border-image: none;\n  border-radius: 5px;\n  box-shadow: 1px 1px 10px 5px #5553;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  border-image: none;\n  border-radius: 5px 5px 0 0 !important;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 10px 10px;\n  display: flex;\n  height: 48px;\n  min-height: 48px;\n  max-height: 48px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n  border-image: none;\n  margin: 3px 2px;\n  padding: 6px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 5px;\n  box-shadow: none;\n  border-image: none;\n  border: #dfe2e6 1px solid;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  font-size: 1.1rem;\n  padding: 7px 5px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 3px 2px;\n  padding: 5px;\n  min-height: 180px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


/* Level 1 */ var CardL1 = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-0"
})(_templateObject());
var CardL1Header = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-1"
})(_templateObject1(), function(props) {
    return props.theme.gray600;
}, function(props) {
    return props.theme.gray100;
});
var CardL1Body = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-2"
})(_templateObject2());
/* Level 2 */ var CardL2 = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-3"
})(_templateObject3());
var CardL2Header = (0,styled_components_browser_esm/* default */.ZP)(CardHeader/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-4"
})(_templateObject4());
var CardL2Body = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9d32e4aa-5"
})(_templateObject5());

// EXTERNAL MODULE: ./src/helpers/useTranslationSafe.ts
var useTranslationSafe = __webpack_require__(87181);
// EXTERNAL MODULE: ./src/components/Common/InfoButton.tsx
var InfoButton = __webpack_require__(79227);
// EXTERNAL MODULE: ./src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(28072);
;// CONCATENATED MODULE: ./src/components/Help/TabMultiDatasetHelp.tsx





function TabMultiDatasetHelp() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoButton/* InfoButton */.R, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("In multi-dataset mode, Nextclade automatically tries to deduce the most appropriate dataset for each sequence, which results with a list of suggested datasets. When running analysis in multi-dataset mode, you will receive separate results (table, tree and exports) for each dataset.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("This is particularly useful, for example, to analyze FASTA files containing a mixture of flu segments (HA, NA) or a mixture of different organisms, or, more generally, what Nextclade treats as different datasets, e.g. RSV-A and RSV-B.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t("Currently, the analysis results obtained for different datasets in multi-dataset mode are still entirely separate. There is no difference between performing a multi-dataset run and performing multiple runs in single-dataset mode one after another. Multi-dataset more is a convenience feature only.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "p-0 m-0 small",
                children: [
                    t("Learn more about datasets in Nextclade {{documentation}}"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* LinkExternal */.N, {
                        href: "https://docs.nextstrain.org/projects/nextclade/en/stable",
                        children: t("documentation")
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Help/TabSingleDatasetHelp.tsx





function TabSingleDatasetHelp() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoButton/* InfoButton */.R, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t('In single-dataset mode all sequences are analyzed using the same dataset. A dataset can be selected manually by clicking on "Select reference dataset" or "Change reference dataset" buttons. Nextclade can also suggest the most appropriate dataset from your sequences.')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t('If no dataset is currently selected, drag and drop some sequence data and click "Suggest" button to launch the suggestion algorithm. Click "Re-suggest" if there is already a dataset selected. You can clear current selection by clicking "Reset" button. ')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t('In single-dataset mode all sequences are analyzed using the same dataset. A dataset can be selected manually by clicking on "Select reference dataset" or "Change reference dataset" buttons. Nextclade can also suggest the most appropriate dataset from your sequences.')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: t('If there is no current selection and if the "Suggest automatically" toggle is enabled (green), then dataset suggestion runs automatically once sequence data is provided and suggested dataset is selected automatically. Automatic suggestion will not override your selected dataset, but might warn you if the selected dataset does not match the sequences provided.')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "p-0 m-0 small",
                children: [
                    t("Learn more about datasets in Nextclade {{documentation}}"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* LinkExternal */.N, {
                        href: "https://docs.nextstrain.org/projects/nextclade/en/stable",
                        children: t("documentation")
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Common/List.tsx
var List = __webpack_require__(54043);
// EXTERNAL MODULE: ./src/components/Main/DatasetInfoCompact.tsx
var DatasetInfoCompact = __webpack_require__(44969);
// EXTERNAL MODULE: ./src/state/autodetect.state.ts + 1 modules
var autodetect_state = __webpack_require__(69068);
;// CONCATENATED MODULE: ./src/components/Main/DatasetMultiList.tsx
function DatasetMultiList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DatasetMultiList_templateObject() {
    var data = DatasetMultiList_taggedTemplateLiteral([
        "\n  flex: 1;\n  overflow: auto;\n  max-height: 320px;\n  opacity: ",
        ";\n"
    ]);
    DatasetMultiList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DatasetMultiList_templateObject1() {
    var data = DatasetMultiList_taggedTemplateLiteral([
        "\n  margin: 5px 0;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  border-bottom: 1px solid #ccc !important;\n\n  &:last-child {\n    border-bottom: none !important;\n  }\n"
    ]);
    DatasetMultiList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function DatasetMultiList() {
    var datasets = (0,es/* useRecoilValue */.sJ)(autodetect_state/* topSuggestedDatasetsAtom */.__);
    var isRunning = (0,es/* useRecoilValue */.sJ)(autodetect_state/* isAutodetectRunningAtom */.Kt);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ul, {
        isBusy: isRunning,
        children: datasets === null || datasets === void 0 ? void 0 : datasets.map(function(dataset) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoCompact/* DatasetInfoCompact */.F, {
                    dataset: dataset
                })
            }, dataset.path);
        })
    });
}
var Ul = (0,styled_components_browser_esm/* default */.ZP)(List/* UlGeneric */.w7).withConfig({
    componentId: "sc-5c19b8f4-0"
})(DatasetMultiList_templateObject(), function(param) {
    var isBusy = param.isBusy;
    return isBusy ? 0.5 : 1;
});
var Li = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-5c19b8f4-1"
})(DatasetMultiList_templateObject1());

// EXTERNAL MODULE: ./src/components/Main/ButtonRun.tsx
var ButtonRun = __webpack_require__(16968);
// EXTERNAL MODULE: ./src/components/Main/SuggestionPanel.tsx
var SuggestionPanel = __webpack_require__(73234);
// EXTERNAL MODULE: ./src/state/inputs.state.ts
var inputs_state = __webpack_require__(67821);
;// CONCATENATED MODULE: ./src/components/Main/SectionDatasetMulti.tsx
function SectionDatasetMulti_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SectionDatasetMulti_templateObject() {
    var data = SectionDatasetMulti_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    SectionDatasetMulti_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionDatasetMulti_templateObject1() {
    var data = SectionDatasetMulti_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n\n  padding: 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n\n  min-height: 200px;\n"
    ]);
    SectionDatasetMulti_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












function SectionDatasetMulti() {
    var topDatasets = (0,es/* useRecoilValue */.sJ)(autodetect_state/* topSuggestedDatasetsAtom */.__);
    var content = (0,react.useMemo)(function() {
        if ((0,lodash.isEmpty)(topDatasets)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDatasetMultiEmpty, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    className: "my-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetMultiList, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    className: "my-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "d-flex w-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRun/* ButtonRun */.H, {
                            className: "ml-auto",
                            singleDatasetMode: false
                        })
                    })
                })
            ]
        });
    }, [
        topDatasets
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                className: "mb-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionPanel/* SuggestionPanel */.wP, {})
                })
            }),
            content
        ]
    });
}
function SectionDatasetMultiEmpty() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var hasRequiredInputs = (0,es/* useRecoilValue */.sJ)(inputs_state/* hasRequiredInputsAtom */.ZX);
    var isRunning = (0,es/* useRecoilValue */.sJ)(autodetect_state/* isAutodetectRunningAtom */.Kt);
    var content = (0,react.useMemo)(function() {
        if (isRunning) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: t("Finding matching datasets...")
            });
        }
        if (hasRequiredInputs) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionPanel/* ButtonSuggest */.Xi, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: t("Please provide sequence data")
        });
    }, [
        hasRequiredInputs,
        isRunning,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerEmpty, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "m-auto",
            children: content
        })
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3f21c28-0"
})(SectionDatasetMulti_templateObject());
var ContainerEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3f21c28-1"
})(SectionDatasetMulti_templateObject1());

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(61577);
// EXTERNAL MODULE: ./src/state/dataset.state.ts
var dataset_state = __webpack_require__(99902);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(80580);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/UncontrolledAlert.js
var UncontrolledAlert = __webpack_require__(86000);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Button.js
var Button = __webpack_require__(21602);
;// CONCATENATED MODULE: ./src/components/Main/DatasetCurrentUpdateNotification.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function DatasetCurrentUpdateNotification_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function DatasetCurrentUpdateNotification_templateObject() {
    var data = DatasetCurrentUpdateNotification_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    DatasetCurrentUpdateNotification_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DatasetCurrentUpdateNotification_templateObject1() {
    var data = DatasetCurrentUpdateNotification_taggedTemplateLiteral([
        "\n  flex: 0;\n"
    ]);
    DatasetCurrentUpdateNotification_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DatasetCurrentUpdateNotification_templateObject2() {
    var data = DatasetCurrentUpdateNotification_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  height: 2.1rem;\n  min-width: 100px;\n  margin-left: auto;\n"
    ]);
    DatasetCurrentUpdateNotification_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










function DatasetCurrentUpdateNotification(param) {
    var dataset = param.dataset;
    var ref;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref1 = _slicedToArray((0,es/* useRecoilState */.FV)((0,dataset_state/* datasetUpdatedAtom */.q)({
        datasetName: dataset.path
    })), 2), datasetUpdated = ref1[0], setDatasetUpdated = ref1[1];
    var setDatasetCurrent = (0,es/* useSetRecoilState */.Zl)(dataset_state/* datasetSingleCurrentAtom */.d5);
    var onDatasetUpdateClicked = (0,react.useCallback)(function() {
        setDatasetCurrent(datasetUpdated);
        setDatasetUpdated(undefined);
    }, [
        datasetUpdated,
        setDatasetCurrent,
        setDatasetUpdated
    ]);
    var changelogUrl = (0,react.useMemo)(function() {
        if ((0,lodash.isNil)(datasetUpdated) || (0,lodash.isNil)(datasetUpdated.path) || (0,lodash.isNil)(datasetUpdated.files) || (0,lodash.isNil)(datasetUpdated.files.changelog)) {
            return undefined;
        }
        var filename = path_browserify_default().basename(datasetUpdated.files.changelog);
        return "https://github.com/nextstrain/nextclade_data/blob/release/data/".concat(datasetUpdated.path, "/").concat(filename);
    }, [
        datasetUpdated
    ]);
    if ((0,lodash.isNil)(datasetUpdated)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        noGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UncontrolledAlert/* default */.Z, {
                closeClassName: "d-none",
                fade: false,
                color: "info",
                className: "mx-1 py-2 px-2 d-flex w-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "my-0",
                                children: t("A new version of this dataset is available.")
                            }),
                            ((ref = datasetUpdated.files) === null || ref === void 0 ? void 0 : ref.changelog) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "my-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* LinkExternal */.N, {
                                    href: changelogUrl,
                                    children: t("What's new?")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeButton, {
                            type: "button",
                            color: "info",
                            title: t("Accept the updated dataset"),
                            onClick: onDatasetUpdateClicked,
                            children: t("Update")
                        })
                    })
                ]
            })
        })
    });
}
var AlertTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5e336ec-0"
})(DatasetCurrentUpdateNotification_templateObject());
var AlertButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5e336ec-1"
})(DatasetCurrentUpdateNotification_templateObject1());
var ChangeButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a5e336ec-2"
})(DatasetCurrentUpdateNotification_templateObject2());

// EXTERNAL MODULE: ./src/components/Main/DatasetInfo.tsx + 2 modules
var DatasetInfo = __webpack_require__(37952);
// EXTERNAL MODULE: ./src/components/Main/ButtonLoadExample.tsx
var ButtonLoadExample = __webpack_require__(54049);
// EXTERNAL MODULE: ./src/components/Main/DatasetCustomizationIndicator.tsx
var DatasetCustomizationIndicator = __webpack_require__(51787);
// EXTERNAL MODULE: ./src/components/Main/LinkOpenTree.tsx
var LinkOpenTree = __webpack_require__(98409);
// EXTERNAL MODULE: ./src/io/fetchDatasets.ts
var fetchDatasets = __webpack_require__(4177);
// EXTERNAL MODULE: ./src/components/Common/Flex.tsx
var Flex = __webpack_require__(33859);
// EXTERNAL MODULE: ./src/components/Main/DatasetInfoAutodetectProgressCircle.tsx
var DatasetInfoAutodetectProgressCircle = __webpack_require__(79488);
;// CONCATENATED MODULE: ./src/components/Main/DatasetSingleCurrent.tsx
function DatasetSingleCurrent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DatasetSingleCurrent_templateObject() {
    var data = DatasetSingleCurrent_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n"
    ]);
    DatasetSingleCurrent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












function DatasetSingleCurrent(param) {
    var dataset = param.dataset;
    (0,fetchDatasets/* useUpdatedDataset */.EI)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        noGutters: true,
        className: "my-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatasetSingleCurrent_Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCurrentUpdateNotification, {
                        dataset: dataset
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        noGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    noGutters: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* FlexContainer */.Ej, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* FlexLeft */.M9, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoAutodetectProgressCircle/* DatasetInfoAutodetectProgressCircle */.W, {
                                                        dataset: dataset,
                                                        showSuggestions: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* FlexRight */.Hz, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfo/* DatasetInfo */.Bu, {
                                                        dataset: dataset
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetCustomizationIndicator/* DatasetCustomizationsIndicatorLink */.GT, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    noGutters: true,
                                    className: "d-flex w-100",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        className: "d-flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex ml-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOpenTree/* LinkOpenTree */.$, {
                                                    className: "ml-1",
                                                    dataset: dataset
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLoadExample/* ButtonLoadExample */.P, {
                                                    className: "ml-1",
                                                    dataset: dataset
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var DatasetSingleCurrent_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f53ec15-0"
})(DatasetSingleCurrent_templateObject());

;// CONCATENATED MODULE: ./src/components/Main/ButtonChangeDataset.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ButtonChangeDataset_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ButtonChangeDataset_templateObject() {
    var data = ButtonChangeDataset_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n\n  padding: 12px;\n  border: 1px #ccc9 solid;\n  border-radius: 5px;\n\n  min-height: 200px;\n"
    ]);
    ButtonChangeDataset_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ButtonChangeDataset_templateObject1() {
    var data = ButtonChangeDataset_taggedTemplateLiteral([
        "\n  min-height: 50px;\n"
    ]);
    ButtonChangeDataset_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function DatasetNoneSection(param) {
    var toDatasetSelection = param.toDatasetSelection;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDataset_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDataset, {
            onClick: toDatasetSelection
        })
    });
}
var ButtonChangeDataset_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-86a28622-0"
})(ButtonChangeDataset_templateObject());
function ButtonChangeDataset(_param) {
    var onClick = _param.onClick, restProps = _objectWithoutProperties(_param, [
        "onClick"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var hasDataset = (0,es/* useRecoilValue */.sJ)(dataset_state/* hasSingleCurrentDatasetAtom */.hG);
    var ref = (0,react.useMemo)(function() {
        var text = hasDataset ? t("Change reference dataset") : t("Select reference dataset");
        return {
            color: hasDataset ? "secondary" : "primary",
            text: text,
            tooltip: text
        };
    }, [
        hasDataset,
        t
    ]), color = ref.color, text1 = ref.text, tooltip = ref.tooltip;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDatasetStyled, _objectSpread({
        className: "m-auto",
        color: color,
        title: tooltip,
        onClick: onClick
    }, restProps, {
        children: text1
    }));
}
var ButtonChangeDatasetStyled = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-86a28622-1"
})(ButtonChangeDataset_templateObject1());

// EXTERNAL MODULE: ./src/components/Main/SuggestionError.tsx
var SuggestionError = __webpack_require__(52222);
;// CONCATENATED MODULE: ./src/components/Main/SuggestionAlertMainPage.tsx
function SuggestionAlertMainPage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function SuggestionAlertMainPage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SuggestionAlertMainPage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SuggestionAlertMainPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SuggestionAlertMainPage_templateObject() {
    var data = SuggestionAlertMainPage_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    SuggestionAlertMainPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuggestionAlertMainPage_templateObject1() {
    var data = SuggestionAlertMainPage_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0.75rem 1rem;\n  width: 100%;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    SuggestionAlertMainPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function SuggestionAlertMainPage(_param) {
    var restProps = _extends({}, _param);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var datasetSingleCurrent = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetSingleCurrentAtom */.d5);
    var topSuggestedDatasets = (0,es/* useRecoilValue */.sJ)(autodetect_state/* topSuggestedDatasetsAtom */.__);
    var numberTopSuggestedDatasets = (0,es/* useRecoilValue */.sJ)(autodetect_state/* numberTopSuggestedDatasetsAtom */.CI);
    var autodetectRunState = (0,es/* useRecoilValue */.sJ)(autodetect_state/* autodetectRunStateAtom */.dZ);
    var alert = (0,react.useMemo)(function() {
        var hasMatch = datasetSingleCurrent && topSuggestedDatasets.some(function(suggestion) {
            return suggestion.path === datasetSingleCurrent.path;
        });
        if (autodetectRunState === autodetect_state/* AutodetectRunState.Failed */.vj.Failed) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionError/* SuggestionError */.a, {});
        }
        if (autodetectRunState === autodetect_state/* AutodetectRunState.Done */.vj.Done) {
            if (datasetSingleCurrent) {
                // There is more than one suggestion and selected dataset is NOT among them
                if (!hasMatch && numberTopSuggestedDatasets > 0) {
                    var text = t("Currently selected dataset does not seem to match your sequences, " + 'but there are {{ n }} other datasets which might. Click "Change reference dataset" to see the list.', {
                        n: numberTopSuggestedDatasets
                    });
                    if (numberTopSuggestedDatasets === 1) {
                        text = t("Currently selected dataset does not seem to match your sequences, " + 'but there is 1 dataset which might. Click "Change reference dataset" to see the list.');
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "warning",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Possible dataset mismatch detected.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: text
                            })
                        ]
                    });
                }
                // There is more than one suggestion and selected dataset is among them
                if (numberTopSuggestedDatasets > 1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "primary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Multiple matching datasets.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: t('{{ n }} datasets appear to match your sequences. Click "Change reference dataset" to see the list or use the "Multiple dataset" mode to analyze your data.', {
                                    n: numberTopSuggestedDatasets
                                })
                            })
                        ]
                    });
                }
            }
            // There are no suggestions
            if (numberTopSuggestedDatasets === 0) {
                if (datasetSingleCurrent) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                        closeClassName: "d-none",
                        fade: false,
                        color: "danger",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "font-weight-bold",
                                children: t("Possible dataset mismatch detected.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "small",
                                children: t("Currently selected dataset does not seem to match your sequences, and the suggestion algorithm was unable to find any alternatives. Select a dataset manually. If there is no suitable dataset, consider creating and contributing one to the Nextclade community dataset collection.")
                            })
                        ]
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert, {
                    closeClassName: "d-none",
                    fade: false,
                    color: "danger",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "font-weight-bold",
                            children: t("No matching datasets.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "small",
                            children: t("Suggestion algorithm was unable to find a dataset suitable for your sequences. Select a dataset manually. If there is no suitable dataset, consider creating and contributing one to the Nextclade community dataset collection.")
                        })
                    ]
                });
            }
        }
        return null;
    }, [
        autodetectRunState,
        datasetSingleCurrent,
        topSuggestedDatasets,
        numberTopSuggestedDatasets,
        t
    ]);
    if (!alert) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        noGutters: true,
        className: "my-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertWrapper, SuggestionAlertMainPage_objectSpread({}, restProps, {
                children: alert
            }))
        })
    });
}
var AlertWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78d1ba2f-0"
})(SuggestionAlertMainPage_templateObject());
var Alert = (0,styled_components_browser_esm/* default */.ZP)(UncontrolledAlert/* default */.Z).withConfig({
    componentId: "sc-78d1ba2f-1"
})(SuggestionAlertMainPage_templateObject1());

;// CONCATENATED MODULE: ./src/components/Main/SectionDatasetSingle.tsx
function SectionDatasetSingle_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SectionDatasetSingle_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SectionDatasetSingle_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SectionDatasetSingle_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SectionDatasetSingle_slicedToArray(arr, i) {
    return SectionDatasetSingle_arrayWithHoles(arr) || SectionDatasetSingle_iterableToArrayLimit(arr, i) || SectionDatasetSingle_unsupportedIterableToArray(arr, i) || SectionDatasetSingle_nonIterableRest();
}
function SectionDatasetSingle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SectionDatasetSingle_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SectionDatasetSingle_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SectionDatasetSingle_arrayLikeToArray(o, minLen);
}
function SectionDatasetSingle_templateObject() {
    var data = SectionDatasetSingle_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    SectionDatasetSingle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














function SectionDatasetSingle() {
    var push = (0,router.useRouter)().push;
    var ref = SectionDatasetSingle_slicedToArray((0,es/* useRecoilState */.FV)(dataset_state/* datasetSingleCurrentAtom */.d5), 2), datasetCurrent = ref[0], setDatasetCurrent = ref[1];
    var autodetectShouldSetCurrentDataset = (0,es/* useRecoilValue */.sJ)(autodetect_state/* autodetectShouldSetCurrentDatasetAtom */.l8);
    var firstTopSuggestedDataset = (0,es/* useRecoilValue */.sJ)(autodetect_state/* firstTopSuggestedDatasetAtom */.dS);
    (0,react.useEffect)(function() {
        if (((0,lodash.isNil)(datasetCurrent) || (0,lodash.isEmpty)(datasetCurrent) || autodetectShouldSetCurrentDataset) && !(0,lodash.isEmpty)(firstTopSuggestedDataset)) {
            setDatasetCurrent(firstTopSuggestedDataset);
        }
    }, [
        autodetectShouldSetCurrentDataset,
        datasetCurrent,
        firstTopSuggestedDataset,
        setDatasetCurrent
    ]);
    var toDatasetSelection = (0,react.useCallback)(function() {
        // eslint-disable-next-line no-void
        void push("/dataset");
    }, [
        push
    ]);
    var content = (0,react.useMemo)(function() {
        if ((0,lodash.isNil)(datasetCurrent) || (0,lodash.isEmpty)(datasetCurrent) || (0,lodash.isNil)(datasetCurrent)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetNoneSection, {
                toDatasetSelection: toDatasetSelection
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !(0,lodash.isNil)(datasetCurrent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetSingleCurrent, {
                    dataset: datasetCurrent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    noGutters: true,
                    className: "my-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        className: "d-flex w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChangeDataset, {
                                className: "mr-auto",
                                onClick: toDatasetSelection
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonRun/* ButtonRun */.H, {
                                className: "ml-auto",
                                singleDatasetMode: true
                            })
                        ]
                    })
                })
            ]
        });
    }, [
        datasetCurrent,
        toDatasetSelection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionDatasetSingle_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                noGutters: true,
                className: "mb-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionPanel/* SuggestionPanel */.wP, {})
                })
            }),
            content,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionAlertMainPage, {
                className: "mt-1 w-100"
            })
        ]
    });
}
var SectionDatasetSingle_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-339481a7-0"
})(SectionDatasetSingle_templateObject());

// EXTERNAL MODULE: ./src/hooks/useToggle.ts
var useToggle = __webpack_require__(83144);
// EXTERNAL MODULE: ./src/components/Main/MainSectionTitle.tsx + 2 modules
var MainSectionTitle = __webpack_require__(87319);
// EXTERNAL MODULE: ./src/hooks/useRunSeqAutodetect.ts
var useRunSeqAutodetect = __webpack_require__(33035);
// EXTERNAL MODULE: ./src/state/error.state.ts
var error_state = __webpack_require__(57635);
// EXTERNAL MODULE: ./src/state/settings.state.ts
var settings_state = __webpack_require__(99664);
// EXTERNAL MODULE: ./src/components/FilePicker/FilePicker.tsx + 13 modules
var FilePicker = __webpack_require__(4905);
// EXTERNAL MODULE: ./src/components/Common/FileIcons.tsx
var FileIcons = __webpack_require__(4052);
;// CONCATENATED MODULE: ./src/components/Main/QuerySequenceFilePicker.tsx
function QuerySequenceFilePicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function QuerySequenceFilePicker_templateObject() {
    var data = QuerySequenceFilePicker_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    QuerySequenceFilePicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function QuerySequenceFilePicker() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var addQryInputs = (0,inputs_state/* useQuerySeqInputs */.HT)().addQryInputs;
    var qrySeqError = (0,es/* useRecoilValue */.sJ)(error_state/* qrySeqErrorAtom */.vm);
    var shouldSuggestDatasetsOnDatasetPage = (0,es/* useRecoilValue */.sJ)(settings_state/* shouldSuggestDatasetsOnDatasetPageAtom */.Ji);
    var icon = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileIcons/* FileIconFasta */.Dt, {});
    }, []);
    var runAutodetect = (0,useRunSeqAutodetect/* useRunSeqAutodetect */.oh)();
    var setSequences = (0,react.useCallback)(function(inputs) {
        addQryInputs(inputs);
        if (shouldSuggestDatasetsOnDatasetPage) {
            runAutodetect();
        }
    }, [
        addQryInputs,
        runAutodetect,
        shouldSuggestDatasetsOnDatasetPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceFilePicker_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilePicker/* FilePicker */.GB, {
            icon: icon,
            exampleUrl: "https://example.com/sequences.fasta",
            pasteInstructions: t("Enter sequence data in FASTA format"),
            input: undefined,
            error: qrySeqError,
            isInProgress: false,
            onInputs: setSequences,
            multiple: true
        })
    });
}
var QuerySequenceFilePicker_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2f68e272-0"
})(QuerySequenceFilePicker_templateObject());

// EXTERNAL MODULE: ./src/components/Main/QuerySequenceList.tsx
var QuerySequenceList = __webpack_require__(55375);
// EXTERNAL MODULE: ./src/components/Help/SelectDatasetHelp.tsx
var SelectDatasetHelp = __webpack_require__(85800);
// EXTERNAL MODULE: ./src/components/Common/TabsFull.tsx
var TabsFull = __webpack_require__(83887);
;// CONCATENATED MODULE: ./src/components/Main/MainInputForm.tsx
function MainInputForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MainInputForm_templateObject() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1200px;\n"
    ]);
    MainInputForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject1() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0;\n  padding-left: 10px;\n  margin-top: 10px;\n  margin-bottom: 3px;\n"
    ]);
    MainInputForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject2() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: -12px;\n  padding: 12px;\n  overflow: hidden;\n"
    ]);
    MainInputForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject3() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: -12px;\n  padding: 12px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: hidden;\n"
    ]);
    MainInputForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject4() {
    var data = MainInputForm_taggedTemplateLiteral([
        ""
    ]);
    MainInputForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MainInputForm_templateObject5() {
    var data = MainInputForm_taggedTemplateLiteral([
        ""
    ]);
    MainInputForm_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = MainInputForm_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex: 1 0;\n  padding-left: 0.75rem;\n  margin: auto 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





















var ContainerFixed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bcee16-0"
})(MainInputForm_templateObject());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bcee16-1"
})(MainInputForm_templateObject1());
var Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5bcee16-2"
})(MainInputForm_templateObject2());
var RowCustom = (0,styled_components_browser_esm/* default */.ZP)(Row/* default */.Z).withConfig({
    componentId: "sc-5bcee16-3"
})(MainInputForm_templateObject3());
function Landing() {
    // This periodically fetches dataset index and updates the list of datasets.
    (0,fetchDatasets/* useUpdatedDatasetIndex */.Uq)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerFixed, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSectionTitle/* MainSectionTitle */.p, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                className: "mt-4 mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowCustom, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 6,
                            className: "d-flex flex-column h-100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCardQuerySeqPicker, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCardDataset, {})
                        })
                    ]
                })
            })
        ]
    });
}
function LandingCardQuerySeqPicker() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var qryInputs = (0,inputs_state/* useQuerySeqInputs */.HT)().qryInputs;
    var title = (0,react.useMemo)(function() {
        if (qryInputs.length > 0) {
            return t("Add more sequence data");
        }
        return t("Provide sequence data");
    }, [
        qryInputs.length,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1, {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardL1Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                    title: title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1Body, {
                className: "d-flex flex-column h-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceFilePicker, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuerySequenceList/* QuerySequenceList */.g2, {})
                ]
            })
        ]
    });
}
function LandingCardDataset() {
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var dataset = (0,es/* useRecoilValue */.sJ)(dataset_state/* datasetSingleCurrentAtom */.d5);
    var text = (0,react.useMemo)(function() {
        if ((0,lodash.isEmpty)(dataset)) {
            return t("Select reference dataset");
        }
        return t("Selected reference dataset");
    }, [
        dataset,
        t
    ]);
    var ref = (0,useToggle/* useRecoilToggle */.T)(dataset_state/* isSingleDatasetTabActiveAtom */.Pj), isSingle = ref.state, setIsSingle = ref.setState;
    var activeTabId1 = isSingle ? "single" : "multi";
    var setActiveTabId = (0,react.useCallback)(function(activeTabId) {
        setIsSingle(activeTabId !== "multi");
    }, [
        setIsSingle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1, {
        className: "d-flex flex-column h-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardL1Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle, {
                    children: [
                        text,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDatasetHelp/* SelectDatasetHelp */.W, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainInputForm_CardL1Body, {
                className: "d-flex flex-column h-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsFull/* TabNav */.KT, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsFull/* TabLabel */.Hu, {
                                tabId: "single",
                                activeTabId: activeTabId1,
                                setActiveTabId: setActiveTabId,
                                children: [
                                    t("Single dataset"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabSingleDatasetHelp, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsFull/* TabLabel */.Hu, {
                                tabId: "multi",
                                activeTabId: activeTabId1,
                                setActiveTabId: setActiveTabId,
                                children: [
                                    t("Multiple datasets"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabMultiDatasetHelp, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsFull/* TabContent */.I5, {
                        activeTab: activeTabId1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsFull/* TabPane */.Jm, {
                                tabId: "single",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDatasetSingle, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsFull/* TabPane */.Jm, {
                                tabId: "multi",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDatasetMulti, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var MainInputForm_CardL1 = (0,styled_components_browser_esm/* default */.ZP)(CardL1).withConfig({
    componentId: "sc-5bcee16-4"
})(MainInputForm_templateObject4());
var MainInputForm_CardL1Body = (0,styled_components_browser_esm/* default */.ZP)(CardL1Body).withConfig({
    componentId: "sc-5bcee16-5"
})(MainInputForm_templateObject5());
var CardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-5bcee16-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/Main/MainPage.tsx
function MainPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MainPage_templateObject() {
    var data = MainPage_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 1 100%;\n  overflow: hidden;\n  padding: 0;\n  margin: 0 auto;\n\n  width: 100%;\n  max-width: 1400px;\n"
    ]);
    MainPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var MainPage_Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17bf850c-0"
})(MainPage_templateObject());
function MainPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPage_Main, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing, {})
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/index.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [361,445,189,557,793,731,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);